import { RETRIEVE_CAREER } from "../actions/types";

const initialState = { career: [], totalRows: 0 };

const careerReducer = (state = initialState, action) => {
  const { type, payload } = action;
  
  switch (type) {
    case RETRIEVE_CAREER:
      return {
        ...state,
        career: payload.data,
        totalRows: payload.count,
      };

    default:
      return state;
  }
};

export default careerReducer;
